import { MutationTree } from 'vuex'
import State, { ISalesRepSearchFilter, ISalesRepresentative } from './types'
import { blankSalesRep, blankSalesRepArray, blankSearchFilters } from './constants'
import { ResponseArray } from '../types'

export const mutations: MutationTree<State> = {
  salesRepLoading(state: State) {
    state.loading = true
    state.error = false
    state.salesReps = blankSalesRepArray
  },
  salesRepLoaded(state: State, salesRep: ISalesRepresentative) {
    state.error = false
    state.activeSalesRep = salesRep
    state.loading = false
  },
  salesRepError(state, errorMessage: string) {
    state.error = true
    state.errorMessage = errorMessage
    state.activeSalesRep = blankSalesRep
    state.loading = false
  },
  salesRepsLoading(state: State) {
    state.error = false
    state.salesReps = blankSalesRepArray
  },
  salesRepsLoaded(state: State, salesReps: ResponseArray<ISalesRepresentative>) {
    state.error = false
    state.salesReps = salesReps
  },
  salesRepsError(state) {
    state.error = true
    state.salesReps = blankSalesRepArray
  },
  salesRepFilterUpdated(state: State, filter: ISalesRepSearchFilter) {
    state.searchFilters = { ...state.searchFilters, ...filter }
  },
  salesRepFilterError(state: State) {
    state.searchFilters = { ...state.searchFilters, ...blankSearchFilters }
  },
}
